module.exports = __webpack_public_path__ + "static/media/53_corporates_block_link.cc660c7b.png";